import React from 'react';
import { Card, CardBody } from 'reactstrap';

import { AutoFocusHeader } from '../../_components/auto-focus-header';
import { StartOverButton } from '../../_components/start-over-button';

export function Goodbye() {
  return (
    <div className="d-flex justify-content-center my-5">
      <Card className="shadow-sm">
        <CardBody>
          <div className="text-center">
            <AutoFocusHeader>
              Thank you for visiting the Precertification Portal.
            </AutoFocusHeader>
            <p className="text-large mt-3">
              Accepting the{' '}
              <span className="fw-bold">
                License for Use Of Current Procedural Terminology (CPT)®–
                Fourth Edition
              </span>
              <br />
              from the American Medical Association is required to continue.
            </p>
            <hr aria-hidden="true" />
            <StartOverButton className="mb-2" label="Start Over" />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
